import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_MEASUREMENT_ID = 'G-EZ50391SKF'; // Your GA4 Measurement ID

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === 'function') {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname + location.search,
        page_title: document.title, // Optionally send the document title
      });
      console.log(`GA4 page_view: ${location.pathname + location.search}`); // For debugging
    }
  }, [location]);

  return null; // This component does not render anything
}

export default AnalyticsTracker; 